import React from 'react';

export const DataTrending = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 512 512"
    fill="none"
  >
    <g clipPath="url(#clip0_3061_1044)">
      <rect
        x="163"
        y="184"
        width="289"
        height="207"
        rx="20"
        fill="url(#paint0_linear_3061_1044)"
      />
      <rect
        x="163"
        y="184"
        width="289"
        height="207"
        rx="20"
        fill="url(#paint1_radial_3061_1044)"
        fillOpacity="0.4"
      />
      <rect
        x="163"
        y="184"
        width="289"
        height="207"
        rx="20"
        fill="url(#paint2_radial_3061_1044)"
        fillOpacity="0.4"
      />
      <rect
        x="163"
        y="184"
        width="289"
        height="207"
        rx="20"
        fill="url(#paint3_radial_3061_1044)"
        fillOpacity="0.4"
      />
      <rect
        x="163"
        y="184"
        width="289"
        height="207"
        rx="20"
        fill="url(#paint4_radial_3061_1044)"
        fillOpacity="0.5"
      />
      <rect
        x="163"
        y="184"
        width="289"
        height="207"
        rx="20"
        fill="url(#paint5_radial_3061_1044)"
        fillOpacity="0.6"
      />
      <rect
        x="163"
        y="184"
        width="289"
        height="207"
        rx="20"
        fill="url(#paint6_radial_3061_1044)"
      />
      <rect
        x="163"
        y="184"
        width="289"
        height="207"
        rx="20"
        fill="url(#paint7_radial_3061_1044)"
      />
      <circle
        cx="413.399"
        cy="182.01"
        r="26.8141"
        fill="url(#paint8_linear_3061_1044)"
      />
      <circle
        cx="413.399"
        cy="182.01"
        r="26.8141"
        fill="url(#paint9_radial_3061_1044)"
      />
      <circle
        cx="167.5"
        cy="185.5"
        r="103.5"
        fill="url(#paint10_radial_3061_1044)"
      />
      <circle
        cx="167.5"
        cy="185.5"
        r="103.5"
        fill="url(#paint11_radial_3061_1044)"
        fillOpacity="0.6"
      />
      <circle
        cx="167.5"
        cy="185.5"
        r="103.5"
        fill="url(#paint12_radial_3061_1044)"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.5 289C224.661 289 271 242.661 271 185.5C271 184.999 270.996 184.499 270.989 184L183 184C171.954 184 163 192.954 163 204V288.904C164.492 288.968 165.992 289 167.5 289Z"
        fill="url(#paint13_radial_3061_1044)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M167.5 289C224.661 289 271 242.661 271 185.5C271 184.999 270.996 184.499 270.989 184L183 184C171.954 184 163 192.954 163 204V288.904C164.492 288.968 165.992 289 167.5 289Z"
        fill="url(#paint14_radial_3061_1044)"
        fillOpacity="0.5"
      />
      <rect
        x="225.682"
        y="330.883"
        width="87"
        height="12.9036"
        rx="6.4518"
        transform="rotate(-45.711 225.682 330.883)"
        fill="url(#paint15_linear_3061_1044)"
      />
      <rect
        x="351.271"
        y="318.503"
        width="136.536"
        height="13.8648"
        rx="6.93238"
        transform="rotate(-66.6421 351.271 318.503)"
        fill="url(#paint16_linear_3061_1044)"
      />
      <rect
        width="87"
        height="12.9036"
        rx="6.4518"
        transform="matrix(-0.725165 -0.688575 -0.688575 0.725165 366.98 329.523)"
        fill="url(#paint17_linear_3061_1044)"
      />
      <circle
        cx="238.64"
        cy="325.23"
        r="21"
        fill="url(#paint18_radial_3061_1044)"
      />
      <circle
        cx="238.64"
        cy="325.23"
        r="21"
        fill="url(#paint19_radial_3061_1044)"
        fillOpacity="0.5"
      />
      <circle
        cx="238.64"
        cy="325.23"
        r="21"
        fill="url(#paint20_radial_3061_1044)"
        fillOpacity="0.8"
      />
      <circle
        cx="293.671"
        cy="271.23"
        r="21"
        fill="url(#paint21_radial_3061_1044)"
      />
      <circle
        cx="293.671"
        cy="271.23"
        r="21"
        fill="url(#paint22_radial_3061_1044)"
        fillOpacity="0.5"
      />
      <circle
        cx="293.671"
        cy="271.23"
        r="21"
        fill="url(#paint23_radial_3061_1044)"
        fillOpacity="0.8"
      />
      <circle
        cx="356.313"
        cy="325.118"
        r="21"
        fill="url(#paint24_radial_3061_1044)"
      />
      <circle
        cx="356.313"
        cy="325.118"
        r="21"
        fill="url(#paint25_radial_3061_1044)"
        fillOpacity="0.8"
      />
      <path
        d="M439.968 185.65C438.192 198.737 426.974 208.824 413.399 208.824C399.26 208.824 387.676 197.88 386.658 184H432C434.832 184 437.527 184.589 439.968 185.65Z"
        fill="url(#paint26_radial_3061_1044)"
      />
      <path
        d="M439.968 185.65C438.192 198.737 426.974 208.824 413.399 208.824C399.26 208.824 387.676 197.88 386.658 184H432C434.832 184 437.527 184.589 439.968 185.65Z"
        fill="url(#paint27_radial_3061_1044)"
      />
      <path
        d="M439.968 185.65C438.192 198.737 426.974 208.824 413.399 208.824C399.26 208.824 387.676 197.88 386.658 184H432C434.832 184 437.527 184.589 439.968 185.65Z"
        fill="url(#paint28_radial_3061_1044)"
        fillOpacity="0.8"
      />
      <path
        d="M439.968 185.65C438.192 198.737 426.974 208.824 413.399 208.824C399.26 208.824 387.676 197.88 386.658 184H432C434.832 184 437.527 184.589 439.968 185.65Z"
        fill="url(#paint29_radial_3061_1044)"
        fillOpacity="0.5"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M271 182V184H272.99C272.996 184.499 273 184.999 273 185.5C273 243.766 225.766 291 167.5 291C165.993 291 164.492 290.968 163 290.906V288.904L161 288.808V204C161 191.85 170.85 182 183 182H271ZM163 204V288.904C164.492 288.968 165.992 289 167.5 289C224.661 289 271 242.661 271 185.5C271 184.999 270.996 184.499 270.989 184H183C171.954 184 163 192.954 163 204Z"
        fill="#F2F1F3"
      />
      <circle cx="160" cy="135" r="1" fill="#AC76FF" />
      <circle cx="116.25" cy="131.25" r="1" fill="#AC76FF" />
      <circle cx="230.75" cy="165.75" r="1" fill="#AC76FF" />
      <circle cx="190" cy="265" r="1" fill="#AC76FF" />
      <circle cx="228.75" cy="253.23" r="1" fill="#AC76FF" />
      <circle cx="195" cy="216.75" r="1" fill="#AC76FF" />
      <circle cx="200.75" cy="225.75" r="1" fill="#AC76FF" />
      <circle cx="238" cy="150.75" r="1" fill="#AC76FF" />
      <circle cx="79.25" cy="156" r="1" fill="#AC76FF" />
      <circle cx="114.25" cy="214.75" r="1" fill="#AC76FF" />
      <circle cx="190" cy="101.5" r="1" fill="#AC76FF" />
      <circle cx="112.25" cy="163.75" r="1" fill="#AC76FF" />
      <circle cx="173.5" cy="128.25" r="1" fill="#AC76FF" />
      <circle cx="153.25" cy="128.75" r="1.5" fill="#AC76FF" />
      <circle cx="100.5" cy="144.25" r="1.5" fill="#AC76FF" />
      <circle cx="205" cy="166.25" r="1.5" fill="#AC76FF" />
      <circle cx="235.5" cy="219" r="1.5" fill="#AC76FF" />
      <circle cx="179" cy="272.73" r="1.5" fill="#AC76FF" />
      <circle cx="187.5" cy="226.75" r="1.5" fill="#AC76FF" />
      <circle cx="133" cy="195.75" r="1.5" fill="#AC76FF" />
      <circle cx="86.5" cy="205.75" r="1.5" fill="#AC76FF" />
      <circle cx="131.5" cy="251.73" r="1.5" fill="#AC76FF" />
      <circle cx="215.5" cy="110.73" r="1.5" fill="#AC76FF" />
      <circle cx="120.25" cy="119.73" r="1.5" fill="#AC76FF" />
      <circle cx="153.25" cy="169.25" r="1.5" fill="#AC76FF" />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_3061_1044"
        x1="434.485"
        y1="170.899"
        x2="241.505"
        y2="578.753"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.367698" stopColor="#E7E7E7" />
        <stop offset="0.713542" stopColor="#C9F5FF" />
      </linearGradient>
      <radialGradient
        id="paint1_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(233.5 339.494) rotate(28.7059) scale(23.9426 38.6494)"
      >
        <stop offset="0.322917" stopColor="#6E7B83" />
        <stop offset="0.713542" stopColor="#9EA8AE" />
        <stop offset="0.957884" stopColor="#E4E9EA" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(288.5 284.494) rotate(23.8387) scale(23.5053 37.9435)"
      >
        <stop offset="0.322917" stopColor="#6E7B83" />
        <stop offset="0.713542" stopColor="#9EA8AE" />
        <stop offset="0.957884" stopColor="#E4E9EA" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(347.5 339.494) rotate(30.9637) scale(23.3238 37.4462)"
      >
        <stop offset="0.332951" stopColor="#6E7B83" />
        <stop offset="0.708333" stopColor="#9EA8AE" />
        <stop offset="1" stopColor="#DFEBEE" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(401.5 196.494) rotate(35.4171) scale(27.6089 42.0078)"
      >
        <stop offset="0.332951" stopColor="#D0D0D0" />
        <stop offset="0.737958" stopColor="#D0D0D0" />
        <stop offset="0.931599" stopColor="#E7E7E7" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(180.5 226.5) rotate(82.0811) scale(134.28 139.451)"
      >
        <stop offset="0.521657" stopColor="#D0D0D0" />
        <stop offset="0.684443" stopColor="#D4F0F7" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(307.5 184) scale(286.613 51.0939)"
      >
        <stop offset="0.326223" stopColor="#D0D0D0" />
        <stop offset="0.769329" stopColor="#E8E8E8" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(493.365 282.447) rotate(-179.187) scale(172.492 489.703)"
      >
        <stop offset="0.173611" stopColor="#D0D0D0" />
        <stop offset="0.458333" stopColor="#E7E4EC" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint8_linear_3061_1044"
        x1="436.963"
        y1="151.802"
        x2="377.489"
        y2="241.834"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.267843" stopColor="#E7E7E7" />
        <stop offset="0.713542" stopColor="#C9F5FF" />
      </linearGradient>
      <radialGradient
        id="paint9_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(420 160) rotate(25.3777) scale(43.1654 30.3806)"
      >
        <stop offset="0.481353" stopColor="#D0D3D5" />
        <stop offset="0.769329" stopColor="#E7E7E7" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(228.454 1.26085) rotate(110.732) scale(464.571 412.011)"
      >
        <stop offset="0.127989" stopColor="#E6D5D0" />
        <stop offset="0.473293" stopColor="#FCF1E8" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(146.435 220.876) rotate(-35.1972) scale(243.886 275.366)"
      >
        <stop offset="0.360983" stopColor="#F8E4D6" stopOpacity="0" />
        <stop offset="0.502277" stopColor="#B9A69A" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(167.5 289.006) rotate(-90) scale(184.536 61.2688)"
      >
        <stop offset="0.363107" stopColor="#B9A69A" />
        <stop offset="0.728744" stopColor="#FFF1E4" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint13_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(168.261 261.301) rotate(-45.3951) scale(248.654 306.794)"
      >
        <stop offset="0.187649" stopColor="#FFD84E" />
        <stop offset="0.369792" stopColor="#FE843A" />
      </radialGradient>
      <radialGradient
        id="paint14_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(217 184) rotate(-180) scale(125.534 55.7931)"
      >
        <stop offset="0.330298" stopColor="#C84B00" />
        <stop offset="0.607194" stopColor="#FF853B" stopOpacity="0" />
      </radialGradient>
      <linearGradient
        id="paint15_linear_3061_1044"
        x1="265.238"
        y1="315.605"
        x2="264.913"
        y2="345.626"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.597549" stopColor="#E2D7CF" />
        <stop offset="0.739583" stopColor="#D5BFAF" />
        <stop offset="0.832491" stopColor="#B89F8C" />
        <stop offset="0.933497" stopColor="#CEBCAF" />
        <stop offset="1" stopColor="#E2D7CF" />
      </linearGradient>
      <linearGradient
        id="paint16_linear_3061_1044"
        x1="413.35"
        y1="302.087"
        x2="413.111"
        y2="334.346"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.597549" stopColor="#E2D7CF" />
        <stop offset="0.739583" stopColor="#D5BFAF" />
        <stop offset="0.832491" stopColor="#B89F8C" />
        <stop offset="0.933497" stopColor="#CEBCAF" />
        <stop offset="1" stopColor="#E2D7CF" />
      </linearGradient>
      <linearGradient
        id="paint17_linear_3061_1044"
        x1="39.5559"
        y1="-15.2778"
        x2="39.2316"
        y2="14.7428"
        gradientUnits="userSpaceOnUse"
      >
        <stop offset="0.597549" stopColor="#E2D7CF" />
        <stop offset="0.739583" stopColor="#D5BFAF" />
        <stop offset="0.832491" stopColor="#B89F8C" />
        <stop offset="0.933497" stopColor="#CEBCAF" />
        <stop offset="1" stopColor="#E2D7CF" />
      </linearGradient>
      <radialGradient
        id="paint18_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(242.612 315.606) rotate(108.435) scale(38.6064)"
      >
        <stop stopColor="#F1FFB7" />
        <stop offset="0.25" stopColor="#B9DC4E" />
        <stop offset="0.645065" stopColor="#6FB12F" />
        <stop offset="1" stopColor="#3E6419" />
      </radialGradient>
      <radialGradient
        id="paint19_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(237.916 346.23) rotate(-90) scale(15.2069 30.0517)"
      >
        <stop stopColor="#3E6419" />
        <stop offset="1" stopColor="#3E6419" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint20_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(238.64 325.23) rotate(97.8153) scale(37.2773)"
      >
        <stop offset="0.446038" stopColor="white" stopOpacity="0" />
        <stop offset="0.841379" stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint21_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(297.643 261.606) rotate(108.435) scale(38.6064)"
      >
        <stop stopColor="#BCF2FF" />
        <stop offset="0.25" stopColor="#4ECBFF" />
        <stop offset="0.645065" stopColor="#0083F5" />
        <stop offset="1" stopColor="#C955FF" />
      </radialGradient>
      <radialGradient
        id="paint22_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(292.947 292.23) rotate(-90) scale(15.2069 30.0517)"
      >
        <stop stopColor="#DEB3FF" />
        <stop offset="1" stopColor="#CC99FF" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint23_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(293.671 271.23) rotate(97.8153) scale(37.2773)"
      >
        <stop offset="0.446038" stopColor="white" stopOpacity="0" />
        <stop offset="0.841379" stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint24_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(360.285 315.494) rotate(108.435) scale(38.6064)"
      >
        <stop offset="0.0677083" stopColor="#FFE39A" />
        <stop offset="0.25" stopColor="#FFB900" />
        <stop offset="0.645065" stopColor="#E68400" />
        <stop offset="1" stopColor="#FFB900" />
      </radialGradient>
      <radialGradient
        id="paint25_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(356.313 325.118) rotate(97.8153) scale(37.2773)"
      >
        <stop offset="0.446038" stopColor="white" stopOpacity="0" />
        <stop offset="0.841379" stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint26_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(417.408 174.327) rotate(120.689) scale(50.6736 50.6736)"
      >
        <stop offset="0.103226" stopColor="#F4A0C3" />
        <stop offset="0.322917" stopColor="#F481B1" />
        <stop offset="0.510417" stopColor="#F272A7" />
        <stop offset="0.78125" stopColor="#EB70A3" />
      </radialGradient>
      <radialGradient
        id="paint27_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(417.762 170.43) rotate(104.486) scale(39.6562 39.6562)"
      >
        <stop stopColor="#FFBCD8" />
        <stop offset="0.806053" stopColor="#FFBCD8" stopOpacity="0" />
      </radialGradient>
      <radialGradient
        id="paint28_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(413.399 182.01) rotate(97.8153) scale(47.5979 47.5979)"
      >
        <stop offset="0.446038" stopColor="white" stopOpacity="0" />
        <stop offset="0.841379" stopColor="white" />
      </radialGradient>
      <radialGradient
        id="paint29_radial_3061_1044"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(412.475 208.824) rotate(-90) scale(19.4171 38.3719)"
      >
        <stop stopColor="#FFB3BB" />
        <stop offset="1" stopColor="#FE625D" stopOpacity="0" />
      </radialGradient>
      <clipPath id="clip0_3061_1044">
        <rect width="512" height="512" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
